import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';
import { PermissionsEnum, CommandStatus, PageInfo, Client, MeterModelVersionsQueryDataIn, MeterSetupVersionDto } from '../../../../../api/api-reference';
import { AuthService } from '../../../../../services/auth.service';
import { PaginationComponent } from '../../../../core/components/pagination/pagination.component';


@Component({
  selector: 'app-meter-model-versions',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    PaginationComponent,
    RouterLink,
  ],
  templateUrl: './meter-model-versions.component.html',
  styleUrl: './meter-model-versions.component.scss'
})
export class MeterModelVersionsComponent implements OnInit {
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public currentPage: number = 1;
  public numberOfReminders: number = 0;
  public lastPageSize: number = 1;
  activeRow: number | null = null;
  isDatepickerOpen = false;
  PermissionsEnum = PermissionsEnum;
  CommandStatus = CommandStatus;
  data: MeterSetupVersionDto[] | undefined = [];
  private meterModelState: { model?: string; firmwareVersion?: string } = {};

  requestData = new MeterModelVersionsQueryDataIn({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    meterModelId: '',
  });

  constructor(
    private toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute,
    private client: Client,
    public authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.meterModelState = {
      model: history.state['model'],
      firmwareVersion: history.state['firmwareVersion'],
    };
    this.route.paramMap.subscribe((params) => {
      if (params.get('id')) {
        //get meter model from url
        this.requestData.meterModelId = params.get('id')?.toString()!;
        this.reloadTable(this.pageNumber);
      }
      else
        //go back
        this.router.navigate(['settings/crud/meter-model']);
    });
  }

  //preview version
  handleRowClick(versionId: string | undefined) {
    this.router.navigate(['/settings/crud/meter-model-associations-setup'], {
      queryParams: {
        versionId: versionId,
        meterModelId: this.requestData.meterModelId,
      },
      state: this.meterModelState,
    });
  }

  //form for new version
  addNew() {
    this.router.navigate(['/settings/crud/meter-model-associations-setup'], {
      queryParams: {
        meterModelId: this.requestData.meterModelId,
      },
      state: this.meterModelState,
    });
  }

  //get all version for this meter model
  reloadTable(page?: number) {
    this.pageNumber = page || 0;
    if (page) this.requestData!.pageInfo!.page = this.pageNumber;

    this.client.queryMeterModelVersions(this.requestData).subscribe({
      next: (response) => {
        this.data = response.data;
        this.numberOfReminders = response.count || 0;
        this.lastPageSize = Math.ceil(this.numberOfReminders / this.pageSize);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  pageChange(value: number) {
    this.currentPage = value;
    this.reloadTable(this.currentPage);
  }
}
